export const PRODUCT_NAME = 'Organizer';
